import { Delete } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { useContext, useState } from "react";
import { VishcorpSettingsContext } from "../context";
import { deletePackageType } from "./functions";
import NewPackageType from "./NewPackageType";

export default function PackageType(props) {
  const { organizationSettings, updateOrganizationSettings } = useContext(
    VishcorpSettingsContext
  );

  const organizationID = organizationSettings?.organizationID;
  const packageTypes = organizationSettings?.packageTypes;
  const [openNewPackageType, setOpenNewPackageType] = useState(undefined);
  const [confirmDelete, setConfirmDelete] = useState(undefined);
  const [selectedPackageType, setSelectedPackageType] = useState(undefined);

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <Paper sx={{ padding: 2, marginLeft: 1, flexGrow: 1 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5">{`Package Types`}</Typography>
          <Button
            onClick={() => setOpenNewPackageType(true)}
            variant="contained"
          >
            New Package Type
          </Button>
        </div>
        <br />
        <TableContainer
          component={Paper}
          style={{ height: "50vh", overflow: "scroll" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Package Type</b>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {packageTypes?.length > 0 &&
                packageTypes?.map((e) => (
                  <TableRow>
                    <TableCell>{e?.name}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setSelectedPackageType(e);
                          setConfirmDelete(true);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <AlertDialog
        customControls={false}
        open={openNewPackageType}
        handleClose={() => setOpenNewPackageType(false)}
        // dialogTitle={`New ${label} Attribute`}
        dialogContent={
          <NewPackageType
            handleClose={() => setOpenNewPackageType(false)}
            organizationID={organizationID}
            onRefresh={updateOrganizationSettings}
          />
        }
      />
      <AlertDialog
        // customControls={false}
        open={confirmDelete}
        handleClose={() => setConfirmDelete(false)}
        handleConfirm={async () => {
          await deletePackageType(
            organizationID,
            selectedPackageType?.name,
            organizationSettings?.organizationTablePrefix
          );
          setConfirmDelete(false);
          updateOrganizationSettings();
        }}
        dialogTitle={`Delete Package Type: ${selectedPackageType?.name}?`}
      />
    </Box>
  );
}
